import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeploymentTimeoutComponent } from './components/deployment-timeout.component';
import { DeploymentWarningModalComponent } from './deployment-warning-modal/deployment-warning-modal.component';
import { SharedModule } from '@carm/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { DeploymentTimeoutService } from './services/deployment-timeout.service';

@NgModule({
  declarations: [
    DeploymentWarningModalComponent,
    DeploymentTimeoutComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
        TranslateModule
    ],
    providers: [
      DeploymentTimeoutService,
    ],
    exports: [
      DeploymentWarningModalComponent,
      DeploymentTimeoutComponent,
    ]
})
export class DeploymentTimeoutModule { }
